import { SectionPage } from './SectionPage';
import { DevicesPanel } from '../features/devices/DevicesPanel';
import { useMe } from '../features/auth/useMe';

export function DevicesPage() {
  const me = useMe();
  return (
    <SectionPage title="Devices & Security">
      <DevicesPanel devices={me.data?.devices ?? []} />
    </SectionPage>
  );
}
